'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { createItemsViewEvent, dataLayerPush, Events, getSearchStats, mapCategoriesFromUrl, PageSectionAnalyticsTracking } from '@libs/analytics';
import { mapYmalProductsToAnalyticsProducts } from '../lib';
import type { YmalProductsSectionTrackerProps } from './ymalProductsCarousel.types';
export function YmalProductsSectionTracker(t0) {
  const $ = _c(8);
  const {
    products,
    children
  } = t0;
  const [sentDataLayer, setSentDataLayer] = useState(false);
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname || $[1] !== products) {
    t1 = () => {
      dataLayerPush({
        event: Events.VIEW_ITEM_LIST,
        ...createItemsViewEvent(mapYmalProductsToAnalyticsProducts(products), "contentful", "standard pdp", mapCategoriesFromUrl(pathname), getSearchStats().searchTerm)
      });
    };
    $[0] = pathname;
    $[1] = products;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !sentDataLayer;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setSentDataLayer(true);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t4 = <PageSectionAnalyticsTracking sectionId="you-may-also-like-products-carousel" eventCallback={t1} enabled={t2} OnIntersect={t3}>{children}</PageSectionAnalyticsTracking>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}